module.exports = __webpack_public_path__ + "media/images/home-bg-6373064a2f6cd03e47a174de111b80c9.png";